export default __webpack_public_path__ + "static/espressif-bc8b6d49c2dc1672b2f37d5991c37e1f.svg";